/**
 * Saat access token kedaluwarsa (401), coba refresh otomatis dengan refresh token.
 * Mengurangi frekuensi OTP/login ulang selama refresh token masih valid.
 */
import axios from 'util/Api';
import { message } from 'antd';
import {
  USER_TOKEN_SET,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
} from '../constants/ActionTypes';

function logoutAndNotify(store) {
  message.error('Sesi anda telah berakhir, silahkan login kembali.');
  setTimeout(() => {
    axios.defaults.headers.common.Authorization = null;
    localStorage.removeItem('tkn');
    localStorage.removeItem('tknref');
    if (store) {
      store.dispatch({ type: USER_DATA, payload: {} });
      store.dispatch({ type: SIGNOUT_USER_SUCCESS });
    }
  }, 2000);
}

export function setupSessionAxios(store) {
  axios.interceptors.response.use(
    (res) => res,
    async (err) => {
      const cfg = err.config;
      if (!err.response || err.response.status !== 401) {
        return Promise.reject(err);
      }
      if (cfg._retry) {
        return Promise.reject(err);
      }
      const reqUrl = (cfg.url || '') + '';
      if (reqUrl.indexOf('t/t/r') !== -1 || reqUrl.indexOf('bo/login') !== -1) {
        return Promise.reject(err);
      }

      const tknref = localStorage.getItem('tknref');
      if (!tknref) {
        logoutAndNotify(store);
        return Promise.reject(err);
      }

      cfg._retry = true;
      try {
        const res = await axios.post(
          't/t/r',
          {},
          {
            headers: { Authorization: 'Bearer ' + tknref },
            _retry: true,
          }
        );
        const body = res.data;
        if (body.sta && body.stacod === 200 && body.data && body.data.atkn) {
          const atkn = body.data.atkn;
          const rtkn = body.data.rtkn;
          localStorage.setItem('tkn', atkn);
          localStorage.setItem('tknref', rtkn);
          axios.defaults.headers.common.Authorization = 'Bearer ' + atkn;
          let dash = null;
          try {
            dash = JSON.parse(localStorage.getItem('dash') || 'null');
          } catch (e) {
            dash = {};
          }
          if (store) {
            store.dispatch({
              type: USER_TOKEN_SET,
              payload: {
                tkn: atkn,
                tknref: rtkn,
                otp: 'false',
                dash: dash || {},
              },
            });
          }
          cfg.headers = cfg.headers || {};
          cfg.headers.Authorization = 'Bearer ' + atkn;
          return axios(cfg);
        }
      } catch (e) {
        /* refresh gagal */
      }
      logoutAndNotify(store);
      return Promise.reject(err);
    }
  );
}
